import links from '@/config/links';

export default {
	computed: {
		inGameTransactionResult() {
			return this.$store.state.inGameTransactionResult;
		},
		redirectUrl() {
			// return this.inGameTransactionResult.redirectUrl;
			// hotfix: 2025-06-05 [MSW][ARENA] 결제 후 WC 미지급 관련(GSTR-1492) 건으로 S to S 로 변경하여 해당부분 수정 진행
			return '';
		},
		orderNumber() {
			return this.inGameTransactionResult.orderNumber;
		},
		orderDate() {
			return this.inGameTransactionResult.date;
		},
		hasPayment() {
			return this.inGameTransactionResult.hasPayment;
		},
		payment() {
			return this.hasPayment && this.inGameTransactionResult.payment;
		},
		paymentMethod() {
			return this.payment && this.payment.paymentMethod ? this.payment.paymentMethod : '';
		},
		supportLink() {
			return links[this.region].supportLink;
		},
	},
	methods: {
		close() {
			this.$a2s.click('error_close');
			if (this.redirectUrl && !this.$store.state.displayCallbackIframe) {
				window.location.replace(this.redirectUrl);
			} else {
				window.close();
			}
		},
		supportTracking() {
			this.$a2s.click('error_support');
			dataLayer.push({
				event: 'In Game Purchase Support Click',
			});
		},
	},
};
